// Translations
import form from '../sections/form/translations/ua'

// Translation: Login > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
